import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    gap: '2px',
    flexDirection: 'column',
    '& input': {
      padding: '0px',
    },
  },
}));

export default useStyles;
